import FasCaretDown from 'components/Legacy/Icons/FasCaretDown'
import * as React from 'react'
import styled from 'styled-components'
import { px, transition } from 'utils'

export type PropsType = {
  readonly direction: 'up' | 'down' | 'left' | 'right'
}

const getRotation: ({ direction }: PropsType) => string = ({ direction }: PropsType) => {
  switch (direction) {
    case 'up':
      return '180deg'
    case 'down':
      return '0'
    case 'left':
      return '90deg'
    case 'right':
      return '-90deg'
    default:
      return '90deg'
  }
}

const TriangleDiv = styled(FasCaretDown)<PropsType>`
  transform: rotate(${getRotation});
  transition: all ${transition('fast')} ease-in;
`

const Triangle = ({ direction }: PropsType) => (
  <TriangleDiv direction={direction} selectable size={px(1.125)} />
)

export default Triangle
